import React, { useState, useEffect } from "react";
import "./ProductPopup.css";
import { backend_url, currency } from "../../App";
import binIcon from "../Assets/bin.png";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ProductPopup = ({ product, onClose }) => {
  const [activeTab, setActiveTab] = useState("details");
  const [reviews, setReviews] = useState([]);
  const [loadingReviews, setLoadingReviews] = useState(false);

  useEffect(() => {
    if (activeTab === "reviews" && product?.id) {
      fetchReviews(product.id);
    }
  }, [activeTab, product?.id]);

  const fetchReviews = (productId) => {
    setLoadingReviews(true);
    fetch(`${backend_url}/api/customerreview?productId=${productId}`)
      .then((res) => res.json())
      .then((data) => {
        const filteredReviews = data.filter((review) =>
          String(review.productId) === String(product.id)
        );
        setReviews(filteredReviews);
      })
      .catch((err) => console.error('Failed to load reviews', err))
      .finally(() => setLoadingReviews(false));
  };

  if (!product) return null;

  // Calculate discount percentage if both prices exist
  const discountPercentage = product.old_price && product.new_price
    ? Math.round(((product.old_price - product.new_price) / product.old_price) * 100)
    : 0;


  const handleDeleteReview = (reviewId) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this review?");
    if (!confirmDelete) return;

    fetch(`${backend_url}/api/customerreview/${reviewId}`, {
      method: "DELETE",
    })
      .then((res) => {
        toast.success("Review deleted successfully")
        setReviews((prev) => prev.filter((r) => r._id !== reviewId));
      })
      .catch((err) => {
        console.error("Error deleting review:", err);
        alert("Failed to delete review.");
      });
  };


  const handleToggleShowHide = (review) => {
    const action = review.showHide ? "hide" : "show";
    const confirmToggle = window.confirm(`Do you want to ${action} this review?`);

    if (!confirmToggle) return;

    fetch(`${backend_url}/api/customerreview/${review._id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ showHide: !review.showHide }),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to update review");
        }
        toast.success(`Review ${action}ed successfully`);
        setReviews((prevReviews) =>
          prevReviews.map((r) =>
            r._id === review._id ? { ...r, showHide: !r.showHide } : r
          )
        );
      })
      .catch((err) => {
        console.error(`Error ${action}ing review:`, err);
        toast.error(`Failed to ${action} review`);
      });
  };


  return (
    <>
      <div className="modal-overlay">
        <div className="modal-content">
          <button className="close-btn" onClick={onClose}>×</button>

          {/* --- Tabs Section --- */}
          <div className="modal-tabs">
            <button
              className={`tab-btn ${activeTab === "details" ? "active" : ""}`}
              onClick={() => setActiveTab("details")}
            >
              Product Details
            </button>
            <button
              className={`tab-btn ${activeTab === "reviews" ? "active" : ""}`}
              onClick={() => setActiveTab("reviews")}
            >
              Reviews ({reviews.length || 0})
            </button>
          </div>

          {/* --- Product Header --- */}
          <div className="modal-header">
            <img src={product.images[0]} alt={product.name} className="modal-image" />
            <div>
              <h2 className="modal-title">{product.name}</h2>
              <p className="modal-description">{product.description}</p>

              <div className="modal-pricing">
                {product.old_price && (
                  <span className="old-price">
                    {currency}
                    {product.old_price}
                  </span>
                )}

                <span className="new-price">
                  {currency}
                  {(
                    product.old_price -
                    (product.old_price * product.new_price) / 100
                  ).toFixed(2)}
                </span>

                {product.new_price > 0 && (
                  <span className="discount-badge">{product.new_price}% OFF</span>
                )}
              </div>
            </div>
          </div>

          {/* --- Product Details --- */}
          {activeTab === "details" && (
            <div className="modal-body">
              <table className="details-table">
                <tbody>
                  <tr>
                    <th>Material</th>
                    <td>{product.material}</td>
                    <th>Weight</th>
                    <td>{product.weight}</td>
                  </tr>
                  <tr>
                    <th>Size</th>
                    <td>{product.size}</td>
                    <th>Color</th>
                    <td>{product.color}</td>
                  </tr>
                  <tr>
                    <th>Quality</th>
                    <td>{product.quality}</td>
                    <th>Scale</th>
                    <td>{product.scale}</td>
                  </tr>
                  <tr>
                    <th>Category</th>
                    <td>{product.category}</td>
                    <th>Subcategory</th>
                    <td>{product.subcategory}</td>
                  </tr>
                  <tr>
                    <th>Status</th>
                    <td>{product.status}</td>
                    <th>Best Seller</th>
                    <td>{product.bestseller}</td>
                  </tr>
                </tbody>
              </table>

              <div className="additional-info">
                {product.note && <p><strong>Note:</strong> {product.note}</p>}
                {product.disclaimer && <p><strong>Disclaimer:</strong> {product.disclaimer}</p>}
                {product.washcare && <p><strong>Wash Care:</strong> {product.washcare}</p>}
              </div>
            </div>
          )}

          {/* --- Reviews Tab --- */}
          {activeTab === "reviews" && (
            <div className="modal-body">
              <h3 className="review-title">Customer Reviews</h3>
              {loadingReviews ? (
                <p className="no-reviews">Loading reviews...</p>
              ) : reviews.length > 0 ? (
                <div className="reviews-grid">
                  {reviews.map((review, index) => (
                    // <div key={index} className="review-card">
                    //   <div className="review-header">
                    //     <div className="review-user-info">
                    //       <span className="review-user">{review.name}</span>
                    //       <span className="review-user">{review.email}</span>
                    //       <span className="review-rating">⭐ {review.rating}/5</span>
                    //     </div>
                    //     <div className="review-actions">
                    //       <button
                    //         className="toggle-review-btn"
                    //         onClick={() => handleToggleShowHide(review)}
                    //       >
                    //         {review.showHide ? "🙈" : "👁️"}
                    //       </button>
                    //       <button
                    //         className="delete-review-btn"
                    //         onClick={() => handleDeleteReview(review._id)}
                    //       >
                    //         <img src={binIcon} alt="recycle" className="delete-img" />
                    //       </button>
                    //     </div>
                    //   </div>

                    //   {review.reviewTitle && (
                    //     <h4 className="review-title-text">{review.reviewTitle}</h4>
                    //   )}
                    //   <p className="review-comment">{review.review}</p>
                    //   {review.reviewImage && (
                    //     <div className="review-image-container">
                    //       <img
                    //         src={`${review.reviewImage}`}
                    //         alt="Review"
                    //         className="review-image"
                    //         onError={(e) => {
                    //           e.target.style.display = 'none';
                    //         }}
                    //       />
                    //     </div>
                    //   )}
                    // </div>

                    <div key={index} className="review-card">
                      <div className="review-header">
                        <div className="review-user-info">
                          <span className="review-user">{review.name}</span>
                          <span className="review-user">{review.email}</span>
                          <span className="review-rating">⭐ {review.rating}/5</span>
                        </div>
                        <button
                          className="delete-review-btn"
                          onClick={() => handleDeleteReview(review._id)}
                        >
                          <img src={binIcon} alt="recycle" className="delete-img" />
                        </button>
                      </div> 

                      {/* Review Content */}
                      {review.reviewTitle && (
                        <h4 className="review-title-text">{review.reviewTitle}</h4>
                      )}
                      <p className="review-comment">{review.review}</p>
                      {review.reviewImage && (
                        <div className="review-image-container">
                          <img
                            src={`${review.reviewImage}`}
                            alt="Review"
                            className="review-image"
                            onError={(e) => {
                              e.target.style.display = 'none';
                            }}
                          />
                        </div>
                      )}

                      {/* --- Show/Hide Button (BOTTOM) --- */}
                      <div className="review-footer">
                        <button
                          className="show-hide-review-btn"
                          onClick={() => handleToggleShowHide(review)}
                        >
                          {review.showHide ? "Hide Review" : "Show Review"}
                        </button>
                      </div>
                    </div>

                  ))}



                </div>
              ) : (
                <p className="no-reviews">No reviews yet.</p>
              )}
            </div>
          )}
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default ProductPopup;